import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface RegisteredTradesFilterInfo {
  dateFrom: string;
  dateTo: string;
  areaId: string;
  propertyStatusId: string;
  propertyTypeId: string;
}

@Module
export default class DashboardModule extends VuexModule {
  registeredTrades = [] as Array<any>;
  auctions = [] as Array<any>;
  estimator = [] as Array<any>;
  registeredAccounts = {} as any;
  brokersAccounts = {} as any;
  marketeersAccounts = {} as any;
  subscriptionsWidget = [] as any;
  brokersAdsPackages = [] as any;
  mapPackages = [] as any;
  ireSummary = [] as any;
  iveSummary = [] as any;
  adsSummery = {} as any;
  othersSummary = [] as any;
  tradesSummary = [] as any;
  auctionsSummary = [] as any;
  adsTypesSummary = [] as any;
  activeAdsTypesSummary = [] as any;
  users = [] as Array<any>;
  ads = [] as Array<any>;

  registeredFilter = {} as RegisteredTradesFilterInfo;
  adsFilter = {} as RegisteredTradesFilterInfo;
  auctionsFilter = {} as RegisteredTradesFilterInfo;
  usersFilter = {} as RegisteredTradesFilterInfo;
  estimatorFilter = {} as RegisteredTradesFilterInfo;

  /**
   * Get registeredTrades list
   * @returns Array<RegisteredTradeObject>
   */
  get registeredTradesDashboard(): Array<any> {
    return this.registeredTrades;
  }

  /**
   * Get filter
   * @returns Array<RegisteredTradeObject>
   */
  get registeredFilterValue(): RegisteredTradesFilterInfo {
    return this.registeredFilter;
  }

  get adsFilterValue(): RegisteredTradesFilterInfo {
    return this.adsFilter;
  }

  get auctionsFilterValue(): RegisteredTradesFilterInfo {
    return this.auctionsFilter;
  }

  get usersFilterValue(): RegisteredTradesFilterInfo {
    return this.usersFilter;
  }

  get estimatorFilterValue(): RegisteredTradesFilterInfo {
    return this.estimatorFilter;
  }

  /**
   * Get auctions list
   * @returns Array<RegisteredTradeObject>
   */
  get auctionsDashboard(): Array<any> {
    return this.auctions;
  }

  /**
   * Get estimator list
   * @returns Array<RegisteredTradeObject>
   */
  get estimatorDashboard(): Array<any> {
    return this.estimator;
  }

  /**
   * Get users list
   * @returns Array<RegisteredTradeObject>
   */
  get usersDashboard(): Array<any> {
    return this.users;
  }

  /**
   * Get ads list
   * @returns Array<RegisteredTradeObject>
   */
  get adsDashboard(): Array<any> {
    return this.ads;
  }

  get registeredAccountsDashboard(): any {
    return this.registeredAccounts;
  }

  get brokersAccountsDashboard(): any {
    return this.brokersAccounts;
  }

  get marketeersAccountsDashboard(): any {
    return this.marketeersAccounts;
  }

  get subscriptionWidgetDashboard(): any {
    return this.subscriptionsWidget;
  }

  get brokersAdsPackagesDashboard(): any {
    return this.brokersAdsPackages;
  }
  get mapPackagesDashboard(): any {
    return this.mapPackages;
  }

  get adsSummeryDashboard(): any {
    return this.adsSummery;
  }

  get iveSummaryDashboard(): any {
    return this.iveSummary;
  }

  get ireSummaryDashboard(): any {
    return this.ireSummary;
  }

  get othersSummaryDashboard(): any {
    return this.othersSummary;
  }

  get tradesSummaryDashboard(): any {
    return this.tradesSummary;
  }

  get auctionsSummaryDashboard(): any {
    return this.auctionsSummary;
  }

  get adsTypesSummaryDashboard(): any {
    return this.adsTypesSummary;
  }

  get activeAdsTypesSummaryDashboard(): any {
    return this.activeAdsTypesSummary;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADE_DASHBOARD](data) {
    this.registeredTrades = data;
  }

  @Mutation
  [Mutations.SET_AUCTIONS_DASHBOARD](data) {
    this.auctions = data;
  }

  @Mutation
  [Mutations.SET_ESTIMATOR_DASHBOARD](data) {
    this.estimator = data;
  }

  @Mutation
  [Mutations.SET_REGISTERED_ACCOUNTS](data) {
    this.registeredAccounts = data;
  }

  @Mutation
  [Mutations.SET_BROKERS_ACCOUNTS](data) {
    this.brokersAccounts = data;
  }

  @Mutation
  [Mutations.SET_MARKETEERS_ACCOUNTS](data) {
    this.marketeersAccounts = data;
  }

  @Mutation
  [Mutations.SET_SUBSCRIPTIONS_WIDGET](data) {
    this.subscriptionsWidget = data;
  }

  @Mutation
  [Mutations.SET_BROKERS_ADS_PACKAGES_DASHBOARD](data) {
    this.brokersAdsPackages = data;
  }

  @Mutation
  [Mutations.SET_MAP_PACKAGES_DASHBOARD](data) {
    this.mapPackages = data;
  }

  @Mutation
  [Mutations.SET_IVE_SUMMARY_DASHBOARD](data) {
    this.iveSummary = data;
  }

  @Mutation
  [Mutations.SET_IRE_SUMMARY_DASHBOARD](data) {
    this.ireSummary = data;
  }

  @Mutation
  [Mutations.SET_ADS_SUMMERY_DASHBOARD](data) {
    this.adsSummery = data;
  }

  @Mutation
  [Mutations.SET_OTHERS_SUMMERY_DASHBOARD](data) {
    this.othersSummary = data;
  }

  @Mutation
  [Mutations.SET_ADS_DASHBOARD](data) {
    this.ads = data;
  }

  @Mutation
  [Mutations.SET_USERS_DASHBOARD](data) {
    this.users = data;
  }

  @Mutation
  [Mutations.SET_TRADES_SUMMARY_DASHBOARD](data) {
    this.tradesSummary = data;
  }

  @Mutation
  [Mutations.SET_AUCTIONS_SUMMARY_DASHBOARD](data) {
    this.auctionsSummary = data;
  }

  @Mutation
  [Mutations.SET_ADS_TYPES_SUMMARY_DASHBOARD](data) {
    this.adsTypesSummary = data;
  }

  @Mutation
  [Mutations.SET_ACTIVE_ADS_TYPES_SUMMARY_DASHBOARD](data) {
    this.activeAdsTypesSummary = data;
  }

  @Action
  [Actions.GET_ADS_DASHBOARD](obj) {
    const params = { dateFrom: '', dateTo: '' };

    ApiService.setAuthorizationHeader();

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    return ApiService.query('/dashboard/ads-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ADS_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_USERS_DASHBOARD](obj) {
    const params = { dateFrom: '', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/user-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_USERS_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_REGISTERED_TRADE_DASHBOARD](obj) {
    // console.log(obj);
    const params = {
      dateFrom: '',
      dateTo: '',
      areaId: 0,
      propertyTypeId: 0,
      propertyStatusId: 0,
    };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);
    if (obj && obj.value.areaId) params.areaId = Number(obj.value.areaId);
    if (obj && obj.value.propertyTypeId)
      params.propertyTypeId = obj.value.propertyTypeId;
    if (obj && obj.value.propertyStatusId)
      params.propertyStatusId = obj.value.propertyStatusId;

    debugger;
    console.log(params);
    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/registered-trades-count', {
      params,
    }).then(({ data }) => {
      debugger;
      this.context.commit(Mutations.SET_REGISTERED_TRADE_DASHBOARD, data);
    });
  }

  @Action
  [Actions.GET_AUCTIONS_DASHBOARD](obj) {
    const params = { dateFrom: '', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/auction-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_AUCTIONS_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_ESTIMATOR_DASHBOARD](obj) {
    const params = { dateFrom: '03/05/2023', dateTo: '' };

    if (obj && obj.value.dateFrom) params.dateFrom = String(obj.value.dateFrom);

    if (obj && obj.value.dateTo) params.dateTo = String(obj.value.dateTo);

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/estimator-count', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ESTIMATOR_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.UPDATE_REGISTERED_TRADE_DASHBOARD_FILTER](val) {
    this.context.commit(Mutations.SET_REGISTERED_TRADES_DASHBOARD_FILTER, val);
  }

  @Action
  [Actions.UPDATE_AUCTIONS_DASHBOARD_FILTER](val) {
    this.context.commit(Mutations.SET_AUCTIONS_DASHBOARD_FILTER, val);
  }

  @Action
  [Actions.UPDATE_ESTIMATOR_DASHBOARD_FILTER](val) {
    this.context.commit(Mutations.SET_ESTIMATOR_DASHBOARD_FILTER, val);
  }

  @Action
  [Actions.UPDATE_USERS_DASHBOARD_FILTER](val) {
    this.context.commit(Mutations.SET_USERS_DASHBOARD_FILTER, val);
  }

  @Action
  [Actions.UPDATE_ADS_DASHBOARD_FILTER](val) {
    this.context.commit(Mutations.SET_ADS_DASHBOARD_FILTER, val);
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADES_DASHBOARD_FILTER](obj) {
    this.registeredFilter.dateFrom = String(obj.dateFrom);
    this.registeredFilter.dateTo = String(obj.dateTo);
    this.registeredFilter.areaId = String(obj.areaId);
    this.registeredFilter.propertyStatusId = String(obj.propertyStatusId);
    this.registeredFilter.propertyTypeId = String(obj.propertyTypeId);
  }

  @Mutation
  [Mutations.SET_AUCTIONS_DASHBOARD_FILTER](obj) {
    this.auctionsFilter.dateFrom = String(obj.dateFrom);
    this.auctionsFilter.dateTo = String(obj.dateTo);
  }

  @Mutation
  [Mutations.SET_ESTIMATOR_DASHBOARD_FILTER](obj) {
    this.estimatorFilter.dateFrom = String(obj.dateFrom);
    this.estimatorFilter.dateTo = String(obj.dateTo);
  }

  @Mutation
  [Mutations.SET_USERS_DASHBOARD_FILTER](obj) {
    this.usersFilter.dateFrom = String(obj.dateFrom);
    this.usersFilter.dateTo = String(obj.dateTo);
  }

  @Mutation
  [Mutations.SET_ADS_DASHBOARD_FILTER](obj) {
    this.adsFilter.dateFrom = String(obj.dateFrom);
    this.adsFilter.dateTo = String(obj.dateTo);
  }

  //DASHBOARD V2

  @Action
  [Actions.GET_REGISTERED_ACCOUNTS](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/accounts-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_REGISTERED_ACCOUNTS, data);
      }
    );
  }

  @Action
  [Actions.GET_BROKERS_ACCOUNTS](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/brokers-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_BROKERS_ACCOUNTS, data);
      }
    );
  }

  @Action
  [Actions.GET_MARKETEERS_ACCOUNTS](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/marketeers-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_MARKETEERS_ACCOUNTS, data);
      }
    );
  }

  @Action
  [Actions.GET_SUBSCRIPTIONS_WIDGET](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();

    return ApiService.query('/dashboard/subscription-sales', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SUBSCRIPTIONS_WIDGET, data);
        return data;
      })
      .catch((error) => {
        console.error('Error fetching subscription widget data:', error);
        throw error;
      });
  }

  @Action
  [Actions.GET_BROKERS_ADS_PACKAGES_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/packages-sales', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_BROKERS_ADS_PACKAGES_DASHBOARD, data);
      }
    );
  }
  @Action
  [Actions.GET_MAP_PACKAGES_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/map-packages-sales', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_MAP_PACKAGES_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_ADS_SUMMERY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;
    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/ads-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ADS_SUMMERY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_OTHERS_SUMMERY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/others-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_OTHERS_SUMMERY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_IVE_SUMMARY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/ive-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_IVE_SUMMARY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_IRE_SUMMARY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/ire-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_IRE_SUMMARY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_TRADES_SUMMARY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/trades-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_TRADES_SUMMARY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_AUCTIONS_SUMMARY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/auctions-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_AUCTIONS_SUMMARY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_ADS_TYPES_SUMMARY_DASHBOARD](obj) {
    const params = {
      dateRange: 'last-7-days',
      showTrend: false,
      dateFrom: '',
      dateTo: '',
    };

    if (obj && obj.dateRange) {
      params.dateRange = String(obj.dateRange);
    }

    if (obj && obj.dateRange === 'custom') {
      params.dateFrom = obj.dateFrom || '';
      params.dateTo = obj.dateTo || '';
    }

    params.showTrend = obj?.showTrend ?? false;

    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/ads-types-summary', { params }).then(
      ({ data }) => {
        this.context.commit(Mutations.SET_ADS_TYPES_SUMMARY_DASHBOARD, data);
      }
    );
  }

  @Action
  [Actions.GET_ACTIVE_ADS_TYPES_SUMMARY_DASHBOARD]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/dashboard/active-ads-types-summary', {}).then(
      ({ data }) => {
        this.context.commit(
          Mutations.SET_ACTIVE_ADS_TYPES_SUMMARY_DASHBOARD,
          data
        );
      }
    );
  }
}
